export default "__VITE_ASSET__tiyIcJg1__"